import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { ListParams } from "../../../admin-api/games";
import { adminApi } from "../../../api-client";
import { queryKeys } from "../../query-keys";

export function useMatches(params: ListParams = {}) {
	return useQuery({
		queryKey: queryKeys.matches.list(params),
		queryFn: () => adminApi.matches.list(params),
		placeholderData: keepPreviousData,
	});
}

export function useMatch(id: string) {
	return useQuery({
		queryKey: queryKeys.matches.detail(id),
		queryFn: () => adminApi.matches.get(id),
		enabled: !!id,
	});
}
